import T from 'lmw-time-format'

export const timeMixin = {
    methods: {
        /**
         * 获取当前时间（格式: 2018年8月15日11:31:0）
         * @returns {string}
         */
        mixin_time_get_date_time() {
            let myDate = new Date()
            let year = myDate.getFullYear()
            let month = myDate.getMonth() + 1
            let day = myDate.getDate()
            let hour = myDate.getHours()
            let min = this.filter_time_zero(myDate.getMinutes())
            let sec = this.filter_time_zero(myDate.getSeconds())
            let nowtime = year + '年' + month + '月' + day + '日' + hour + ':' + min + ':' + sec
            return nowtime
        },
        /**
         * 分、秒为个位数时前面加0
         * @param str
         * @returns {*}
         */
        filter_time_zero(num) {
            num = String(num)
            if (num.length < 2) {
                num = '0' + num
            }
            return num
        },

        /**
         * 获取当天日期
         * 格式 20180923
         */
        mixin_time_get_today(line = false) {
            let myDate = new Date()
            let year = myDate.getFullYear()
            let month = this.filter_time_zero(myDate.getMonth() + 1)
            let day = this.filter_time_zero(myDate.getDate())
            let today
            if (line){
              today = year + '-' + month + '-' + day
            }else {
              today = year + month + day
            }
            return today
        },
        /**
       * 获取以今天往后第几天为起始的为期七天的日期数组
       */
        mixin_time_spell(value) {
            let now = new Date().getTime()
            let dateArr = new Array(7).fill(0).map((r, i) => {
                let t = now + (i + value) * 24 * 3600 * 1000
                return T(t, '%Y%m%d')
            })
            return dateArr
        },

      /**
       * 获取本周是今年的第几周
       * @returns {number}
       */
      mixin_time_get_weeks_num() {
        let today = new Date();
        let firstDay = new Date(today.getFullYear(),0, 1);
        let dayOfWeek = firstDay.getDay();
        let spendDay= 1;
        if (dayOfWeek !=0) {
          spendDay=7-dayOfWeek+1;
        }
        firstDay = new Date(today.getFullYear(),0, 1+spendDay);
        let d =Math.ceil((today.valueOf()- firstDay.valueOf())/ 86400000);
        let result =Math.ceil(d/7);
        return result+1;
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/time.js